import { CREATED_AT, DEFAULT_ATTRIBUTES, RESULT, TYPE, UID } from 'shared/api/query/constants';
import {
  aiChat as aiChatConfig,
  aiChatMessage as aiChatMessageConfig,
  user as userConfig,
} from 'shared/api/query/configs.json';
import { reverseEdge } from 'shared/api/query/edges';
import { searchTermFilter } from '@/lib/filter/search-term';

export const listChildren = [
  ...DEFAULT_ATTRIBUTES,
  { attr: aiChatConfig.edges.title, default: '' },
  {
    attr: aiChatConfig.edges.creator,
    model: userConfig.model,
    children: [{ attr: UID }],
    default: null,
  },
];

export const children = [
  ...listChildren,
  {
    attr: reverseEdge(aiChatMessageConfig.edges.chat),
    alias: 'messages',
    model: aiChatMessageConfig.model,
    order: [{ attr: CREATED_AT, desc: false }],
    children: [{ attr: UID }],
    default: [],
  },
];

export const chatList = ({ pagination, searchTerm = '' }) => [
  {
    alias: RESULT,
    model: aiChatConfig.model,
    func: { name: TYPE, args: [{ value: aiChatConfig.model }] },
    filter: searchTermFilter({ searchTerm, edgeName: aiChatConfig.edges.title }),
    order: [{ attr: CREATED_AT, desc: true }],
    children: listChildren,
    pagination,
    default: [],
  },
];
